import { Operators } from "../../../../fetch-xml/filter/Operators";
import { ICondition } from "./ICondition";

export class NumberCondition implements ICondition {
    public isValid(value: number | null, cond: ComponentFramework.PropertyHelper.DataSetApi.ConditionExpression): boolean {
        //@ts-ignore - conditionValue does arrive as a number
        const conditionValue = cond.value as number;
        switch (cond.conditionOperator) {
            case Operators.Equal.Value: {
                return value === conditionValue;
            }
            case Operators.DoesNotEqual.Value: {
                return value !== conditionValue;
            }
            case Operators.GreaterThan.Value: {
                return value !== null ? value > conditionValue : false;
            }
            case Operators.GreaterThanOrEqual.Value: {
                return value !== null ? value >= conditionValue : false;
            }
            case Operators.LessThan.Value: {
                return value !== null ? value < conditionValue : false;
            }
            case Operators.LessThanOrEqual.Value: {
                return value !== null ? value <= conditionValue : false;
            }
            case Operators.DoesNotContainData.Value: {
                return value === null;
            }
            case Operators.ContainsData.Value: {
                return value !== null;
            }
        }
        return true;
    }

}